var map = {
	"./About-Path.svg": "lxqc",
	"./down-arrow.svg": "88lS",
	"./facebook.svg": "85DX",
	"./instagram.svg": "OCqi",
	"./location.svg": "UqX2",
	"./logo-color.svg": "G8lN",
	"./logo-white.svg": "kaZ4",
	"./pause.svg": "5Y8l",
	"./play.svg": "cHMr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 11